<script>
import FormBlock from '@/components/FormBlock.vue';
import BaseTableHeaderItem from '@/components/base/BaseTableHeaderItem.vue';
import MaterialRow from '@/components/exchange/material/MaterialRow.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import utils from '@/utils/common';
import { units } from '@/utils/enum';
import EmptyList from '@/components/ui/EmptyList.vue';

const supplierSortFn = (a, b) => (a.mainBid?.supplierManual?.name ?? '').localeCompare((b.mainBid?.supplierManual?.name ?? ''));
const nameSortFn = (a, b) => (a.name ?? '').localeCompare((b.name ?? ''));
const headers = [
  { title: 'Название',  sortFn: nameSortFn , defaultSort: true                                                                                                }, // eslint-disable-line
  { title: 'Категория',                                                                                              }, // eslint-disable-line
  { title: 'Размер',                                                                                               }, // eslint-disable-line
  { title: 'Помещения',                                                                                             }, // eslint-disable-line
  { title: 'Поставщик',      sortFn: supplierSortFn }, // eslint-disable-line
  { title: 'Кол-во',                                                                                              }, // eslint-disable-line
  { title: 'Сумма',                                                                                            }, // eslint-disable-line
  { title: 'Поставка',                                                                                         }, // eslint-disable-line
  { title: 'Статус',                                                                                           }, // eslint-disable-line
  { title: 'Файл',                                                                                             }, // eslint-disable-line
];

export default {
  name: 'MaterialsTable',
  components: {
    EmptyList,
    BaseCheckbox,
    FormBlock,
    BaseTableHeaderItem,
    MaterialRow,
  },
  props: {
    items: Array,
    checked: Array,
    categories: Array,
  },
  data() {
    return {
      sort: null,
      order: true,
    };
  },
  computed: {
    headers() {
      return headers.map(header => ({ header, sort: this.sortComputed === header, order: this.order }));
    },
    sortComputed() {
      return this.sort ?? (headers ?? []).find(i => !!i.sortFn && i.defaultSort);
    },
    areAllChecked() {
      if (this.checked.length === 0) return false;

      for (let i = 0; i < this.items.length; i += 1) {
        if (!this.checked.includes(this.items[i].id)) {
          return false;
        }
      }

      return true;
    },
    itemsSorted() {
      const sort = this.sort ?? this.sortComputed;
      return sort
        ? [...this.items].sort((a, b) => sort.sortFn(a, b) * (this.order ? 1 : -1))
        : [...this.items];
    },
    itemsQty() {
      return utils.pluralWord(this.items.length, 'позиция', 'позиции', 'позиций');
    },
    suppliersQty() {
      const qty = new Set(this.items.filter(i => i.mainBid?.supplierManual).reduce((acc, val) => [...acc, val.mainBid.supplierManual.id], [])).size;
      return utils.pluralWord(qty, 'поставщик', 'поставщика', 'поставщиков');
    },
    totalCost() {
      return this.items
        .filter(i => i.mainBid && i.mainBid.price && i.mainBid.quantity && i.mainBid.priceCurrency)
        .reduce((acc, val) => {
          const { price, priceCurrency, quantity } = val.mainBid;
          const currency = units.currency[priceCurrency] ?? '';
          acc[currency] ??= 0;
          acc[currency] += price * quantity;
          return acc;
        }, {});
    },
  },
  methods: {
    sortBy(header) {
      if (this.sort === header) {
        this.order = !this.order;
      } else {
        this.sort = header;
        this.order = header.defaultOrder ?? this.order ?? true;
      }
    },
    checkAll() {
      const newState = !this.areAllChecked;
      const items = this.items.map(i => i.id);
      this.$emit('checkMaterial', { items, newState });
    },
  },
};
</script>

<template lang="pug">
FormBlock.materials-table
  .empty(v-if="items.length === 0")
    Icon(name="no-materials")
    | Нет материалов
    Btn(green round @click="$emit('addMaterial')") Добавить материал
  template(v-else)
    .headers
      BaseCheckbox(:value="areAllChecked" @change="checkAll")
      BaseTableHeaderItem(v-for="header in headers" :key="header.header.title" :class="{ [header.header.className]: true }" v-bind="header" @sort="sortBy")
      button.add(@click="$emit('addMaterial')")
        Icon(name="plus2" pointer)
    .body
      MaterialRow(
        v-for="item in itemsSorted"
        :key="item['@id']"
        :item="item"
        :categories="categories"
        :checked="checked.includes(item.id)"
        @check="$emit('checkMaterial', { items: [item.id], newState: $event })"
        @update="$emit('updateMaterial', item)"
        @delete="$emit('deleteMaterial', item)"
        @selectBid="$emit('selectBid', { material: item, bid: $event })"
        @createBid="$emit('createBid', { material: item, bid: $event })"
        @updateBid="$emit('updateBid', $event)"
        @deleteBid="$emit('deleteBid', $event)"
      )
    .footer Итого:
      .items-qty {{ itemsQty }}
      .suppliers-qty {{ suppliersQty }}
      .total-cost(v-if="Object.keys(totalCost).length")
        div(v-for="(val, currency) in totalCost" :key="val + currency") {{ val }} {{ currency }}
</template>

<style scoped lang="scss">
.empty {
  border: 1px solid #EBEFF2;
  box-sizing: border-box;
  border-radius: 6px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #99A3C5;
  gap: 30px;
  padding: 40px;
}

.headers {
  padding: 0 40px 0 20px;
  gap: 12px;
  display: grid;
  //grid-template-columns: 22px 1fr 100px 90px 170px 130px 80px 100px 120px 130px 120px 24px;
  grid-template-columns: 22px 55px 15fr 12fr 9fr 17fr 13fr 8fr 10fr 12fr 13fr 12fr 24px;
  position: relative;
  margin-bottom: 17px;

  & > :nth-child(2) {
    grid-column: 2 / 2 span;
  }
}

.add {
  position: absolute;
  right: 0;
  top: 50%;
  translate: 0 -50%;
  background: transparent;

  svg {
    width: 20px;
    height: 20px;
  }
}

.body {
  display: grid;
  gap: 1px;
}

.footer {
  display: flex;
  align-items: center;
  gap: 30px;
  padding-top: 30px;
  font-size: 18px;
  line-height: 24px;
  color: #92A0B0;

}

.suppliers-qty {
  margin-left: auto;
  color: #1E3147;
}

.items-qty {
  font-size: 14px;
  color: #33A1FB;
}

.total-cost {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  color: #33A1FB;
  margin-left: 150px;
}
</style>
